export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.583 3.75L3.75 8.583v6.834l4.833 4.833h6.834l4.833-4.833V8.583L15.417 3.75H8.583zm-.31-1.5h7.455a.75.75 0 01.53.22l5.272 5.272c.141.14.22.331.22.53v7.456a.75.75 0 01-.22.53l-5.272 5.272a.75.75 0 01-.53.22H8.272a.75.75 0 01-.53-.22L2.47 16.258a.75.75 0 01-.22-.53V8.272a.75.75 0 01.22-.53L7.742 2.47a.75.75 0 01.53-.22z\" fill=\"#6F7488\"/><path d=\"M13 17a1 1 0 11-2 0 1 1 0 012 0z\" fill=\"#6F7488\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12 6.25a.75.75 0 01.75.75v7a.75.75 0 01-1.5 0V7a.75.75 0 01.75-.75z\" fill=\"#6F7488\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};